module.exports = __webpack_public_path__ + "img/no-avatar.ce96f7b4.png";